import { useState, useEffect, useCallback } from 'react';

import { HeaderActions, OutsideLoginObj, OutsideLoginConfig } from './types';

declare global {
  interface Window {
    OutsideLogin?: OutsideLoginObj;
  }
}

export const useOutsideLogin = (params?: Partial<OutsideLoginConfig>) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [outsideLogin, setOutsideLogin] = useState<Partial<OutsideLoginObj>>(
    {}
  );

  // initialize and mount ssoheader on configured selector
  const init = useCallback(() => {
    if (outsideLogin.init) {
      outsideLogin.init(params);
    }
  }, [outsideLogin.init, params]);

  const logout = useCallback(() => {
    if (outsideLogin.signout) {
      outsideLogin.signout();
    }
  }, [outsideLogin.signout]);

  // provide functions to be called onClick for header buttons
  const setHeaderButtonCallbacks = useCallback(
    (param: HeaderActions) => {
      if (outsideLogin.setButtonCalls) {
        outsideLogin.setButtonCalls(param);
      }
    },
    [outsideLogin.setButtonCalls]
  );

  const clearHeaderButtonCallbacks = useCallback(() => {
    if (outsideLogin.setButtonCalls) {
      outsideLogin.setButtonCalls({
        join: null,
        signin: null,
        profile: null
      });
    }
  }, [outsideLogin.setButtonCalls]);

  // shows the join now overlay
  const showJoinNow = useCallback(() => {
    if (outsideLogin.showJoinNow) {
      outsideLogin.showJoinNow();
      return true;
    }

    return false;
  }, [outsideLogin.showJoinNow]);

  // shows the SignUpMember overlay
  const showSignUpMember = useCallback(() => {
    if (outsideLogin.showSignUpMember) {
      outsideLogin.showSignUpMember();
      return true;
    }

    return false;
  }, [outsideLogin.showSignUpMember]);

  // shows the SignUpFree overlay
  const showSignUpFree = useCallback(() => {
    if (outsideLogin.showSignUpFree) {
      outsideLogin.showSignUpFree();
      return true;
    }

    return false;
  }, [outsideLogin.showSignUpFree]);

  const checkApolloAuth = useCallback(() => {
    if (outsideLogin.checkApolloAuth) {
      outsideLogin.checkApolloAuth();
      return true;
    }

    return false;
  }, [outsideLogin.checkApolloAuth]);

  useEffect(() => {
    if (!isLoaded && window.OutsideLogin) {
      setIsLoaded(true);
      setOutsideLogin(window.OutsideLogin);
    }
  });

  return {
    isLoaded,
    init,
    logout,
    setHeaderButtonCallbacks,
    clearHeaderButtonCallbacks,
    showJoinNow,
    showSignUpMember,
    showSignUpFree,
    checkApolloAuth,
    outsideLogin
  };
};
